import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import { useCanvaTokenExchange } from '@/api/useCanva'
import { getCodeVerifier, getRedirectUri, storeCanvaTokens } from '@/lib/canvaOAuth'
import { Spinner } from '@/components/ui'
import { ROUTES } from '@/constants/routes'
import { logger } from '@/lib/logger'

export function CanvaCallback() {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const tokenExchange = useCanvaTokenExchange()

    useEffect(() => {
        const code = searchParams.get('code')
        const error = searchParams.get('error')
        const errorDescription = searchParams.get('error_description')

        logger.debug('Canva callback params:', {
            code: code ? `${code.substring(0, 10)}...` : null,
            error,
            errorDescription,
            allParams: Object.fromEntries(searchParams.entries()),
        })

        if (error) {
            logger.error('Canva auth error:', { error, errorDescription })
            toast.error(errorDescription || `Error de Canva: ${error}`)
            navigate(ROUTES.projects)
            return
        }

        if (!code) {
            toast.error('No se recibió código de autorización')
            navigate(ROUTES.projects)
            return
        }

        const codeVerifier = getCodeVerifier()
        if (!codeVerifier) {
            toast.error('La sesión de autorización expiró. Intenta de nuevo.')
            navigate(ROUTES.projects)
            return
        }

        const redirectUri = getRedirectUri()
        logger.debug('Exchanging token with:', { redirectUri, codeVerifier: `${codeVerifier.substring(0, 10)}...` })

        tokenExchange.mutate(
            {
                code,
                redirect_uri: redirectUri,
                code_verifier: codeVerifier,
            },
            {
                onSuccess: (data) => {
                    storeCanvaTokens(data.access_token, data.refresh_token, data.expires_in)
                    toast.success('Canva conectado')
                    navigate(ROUTES.projects, { state: { openCanvaImport: true } })
                },
                onError: (err) => {
                    logger.error('Token exchange failed:', err)
                    toast.error('Error al conectar con Canva. Intenta de nuevo.')
                    navigate(ROUTES.projects)
                },
            }
        )
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column', gap: '1rem' }}>
            <Spinner size="lg" />
            <p style={{ color: 'var(--color-text-muted)' }}>Conectando con Canva...</p>
        </div>
    )
}
